<span class="tenant-chip" role="img" [attr.aria-label]="tenantLabel()">
  @if (logo(); as l) {
    @if (l.kind === 'wordmark') {
      <!-- Recoloured via CSS mask so the single-colour wordmark inherits the
           chip's text colour (white on the header, dark on light surfaces) —
           no plate, no frame. -->
      <span
        class="tenant-chip__wordmark"
        [style.-webkit-mask-image]="'url(' + l.src + ')'"
        [style.mask-image]="'url(' + l.src + ')'"
        aria-hidden="true"
      ></span>
    } @else {
      <img class="tenant-chip__icon" [src]="l.src" alt="" aria-hidden="true" />
    }
  } @else {
    <span class="tenant-chip__monogram" aria-hidden="true">{{ monogram() }}</span>
  }
  @if (showLabel()) {
    <span class="tenant-chip__label">{{ tenantLabel() }}</span>
  }
</span>
